import React from 'react';
import ReactDOM from 'react-dom/client';
import "./assets/css/bootstrap.min.css"
import './index.css';
import "./assets/css/style.min.css";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
);



if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      console.log('Service Worker registered at', reg.scope);
      // Optional: listen to messages
      navigator.serviceWorker.addEventListener('message', (ev) => {
        console.log('SW message', ev.data);
      });
    }).catch(err => console.error('SW reg failed', err));
  });
}

  {/* </React.StrictMode> */}


